<template>
  <PageLayout>
    <FlashMessage />
    <b-container class="main-cont-corp-prof">
      <div class="profile">
        <div class="profile-back">
          <a
            class="profile-back-btn"
            @click.prevent="goToHome"
          >
            <i class="material-icons vtd-icon-2 vtd-mr-3"></i><span>Go To Portal Home Page</span>
          </a>  
        </div>
      </div>

      <div class="profile company-name">
        <b-row>
          <b-col cols="8">
            <h3>Company Name: {{ userData.companyname }}</h3>
          </b-col> 
          <b-col
            cols="4"
            class="corp-profile-header-image-block"
          >
            <b-img
              class="corp-profile-header-image"
              src="https://cdn.trailfinders.com/k9os0u3ty0_tf_corporate-logo.png"
              fluid
            />
          </b-col>
        </b-row>
      </div>
      <div class="profile corp-profile-contacts-block">

        <Contact
          v-for="(contactmain, i) in userData.contactmain"
          :key="i+'m'"
          ref="contactMainRef"
          :title="'Travel Policy Maker'"
          :contact="contactmain"
        />
        <Contact
          v-for="(contactorganiser, i) in userData.contactorganiser"
          :key="i+'o'"
          ref="contactOrganiserRef"
          :title="'Travel Organiser'"
          :subtitle="'A contact who can make bookings'"
          :contact="contactorganiser"
        />
        <Contact
          v-for="(newContact, i) in newContacts"
          :key="i+'n'"
          ref="contactNewRef"
          :title="'Travel Organiser'"
          :subtitle="'A contact who can make bookings'"
          :contact="newContact"
          :deleteContact="i === newContacts.length - 1 ? () => {deleteNew(i)} : null"
        />
        <div></div>
         <b-row>
        <b-col class="btn-container-corp">
          <b-button 
            type="button"
            class="vtd-btn vtd-btn-danger btn-home-corp"
            @click="goToHome"
          >
            <i class="material-icons vtd-icon-2 mr-2"></i>
            <span>Exit</span>
          </b-button>
          <b-button 
            type="button"
            class="vtd-btn vtd-btn-primary btn-add-corp"
            @click="add"
          >
            <i class="material-icons vtd-icon-2 mr-2">add_circle</i>
            <span>Add</span>
          </b-button>
          <b-button 
            type="button"
            class="vtd-btn vtd-btn-success btn-save-corp"
            @click="onSave"
          >
            <i class="material-icons vtd-icon-2 mr-2"></i>
            <span>Save</span>
          </b-button>
        </b-col>
      </b-row>
      </div>
    </b-container>  
  </PageLayout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import PageLayout from "@/partials/page-layout/corporate"
import Contact from "./contact"
import FlashMessage from "@/partials/flash-message"
import { contactsToEmail } from "../corporate.module"

export default {  
  components: {
    PageLayout,
    Contact,
    FlashMessage
  },
  data() {
    return {
      newContacts: []
    }
  },
  computed: {
    ...mapGetters({
      userData: 'auth/getUserData'
    })
  },
  methods: {
    ...mapActions({
      flashMessageSet: 'flashMessage/set',
      saveCorpContacts: 'corporate/saveContactsAction'
    }),
    deleteNew(i) {
      this.newContacts.pop() 
    },
    add() {
      this.newContacts.push({})
    },
    goToHome() {
      this.$router.push('/landing-corp')
    },
    onSave() {
      let contacts = {
        mainOrig: [],
        organiserOrig: [],
        main: [],
        organiser: [],
        new: []
      }
      if (this.userData.contactmain) {
        contacts.mainOrig = this.userData.contactmain
      }
      if (this.userData.contactorganiser) {
        contacts.organiserOrig = this.userData.contactorganiser
      }
      let failed = false
      if (this.$refs && Array.isArray(this.$refs.contactMainRef)) {
        this.$refs.contactMainRef.map(contact => {
          const contactDataResult = contact.onSubmit()
          if (!contactDataResult) {
            failed = true
          } else {
            contacts.main.push(contactDataResult)
          }
        })
      }
      if (this.$refs && Array.isArray(this.$refs.contactOrganiserRef)) {
        this.$refs.contactOrganiserRef.map(contact => {
          const contactDataResult = contact.onSubmit()
          if (!contactDataResult) {
            failed = true
          } else {
            contacts.organiser.push(contactDataResult)
          }
        })
      }
      if (this.$refs && Array.isArray(this.$refs.contactNewRef)) {
        this.$refs.contactNewRef.map(contact => {
          const contactDataResult = contact.onSubmit()
          if (!contactDataResult) {
            failed = true
          } else {
            contacts.new.push(contactDataResult)
          }
        })
      }
      if (failed) {
        this.flashMessageSet({ type: 'error', message: 'Check some contact have empty fields.' })
      } else {
        
        this.saveCorpContacts(contacts)
      }
      
    }
  }
}
</script>

<style lang="scss" scoped>
  @import './style.scss';
</style>
